import React from 'react';
import './index.scss';
import PropTypes from 'prop-types';

// THE DIFFERENCE BETWEEN THIS COMPONENT AND FloatMenu IS THAT THIS ONE DOES NOT HAVE ANY MENU ITEMS,
// IT IS JUST A CONTAINER FOR OTHER COMPONENTS

const BaseFloatMenu = ({
    top,
    left,
    right,
    bottom,
    children,
    className = '',
    animated = true,
}) => {
    return (
        <div
            className={`dg-base-float-menu ${animated ? 'animate__animated animate__fadeIn animate__faster' : ''} ${className} `}
            style={{
                top: top !== 'undefined' ? top + 'px' : 'unset',
                left: left !== 'undefined' ? left + 'px' : 'unset',
                bottom: bottom !== 'undefined' ? bottom + 'px' : 'unset',
                right: right !== 'undefined' ? right + 'px' : 'unset',
            }}
        >
            {children}
        </div>
    );
};

BaseFloatMenu.propTypes = {
    top: PropTypes.number,
    left: PropTypes.number,
    right: PropTypes.number,
    bottom: PropTypes.number,
};

export default BaseFloatMenu;
